import { render, staticRenderFns } from "./WhitePollutionAdviceView.vue?vue&type=template&id=58fdc736&scoped=true&"
import script from "./WhitePollutionAdviceView.vue?vue&type=script&lang=js&"
export * from "./WhitePollutionAdviceView.vue?vue&type=script&lang=js&"
import style0 from "./WhitePollutionAdviceView.vue?vue&type=style&index=0&id=58fdc736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fdc736",
  null
  
)

export default component.exports